import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AuthService } from "../core/auth/auth.service";
import { AppConfig } from 'src/config/app.config';
import { NotificationService } from '../core/notification.service';
import { AppNotification, NotificationSeverity } from '../core/notification.model';

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit, OnDestroy {
  _apiUrl;
  userName;
  userEmail;
  userRole;
  userId;
  walletBalance: number;
  private isAuthorizedSubscription: Subscription = new Subscription();
  public isAuthorized = false;
  DealerReg: boolean;

  notifications: AppNotification[] = [];
  unreadCount: number = 0;
  notifPanelOpen: boolean = false;
  private notifSub: Subscription = new Subscription();

  toastQueue: { message: string; id: number; severityClass: string }[] = [];
  private toastCounter = 0;
  private toastTimers: ReturnType<typeof setTimeout>[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private appConfig: AppConfig,
    private notifService: NotificationService
  ) {
    this._apiUrl = appConfig.baseUrl;
    this.userName = localStorage.getItem("USER_NAME");
    this.userEmail = localStorage.getItem("USER_EMAIL");
    this.userRole = atob(localStorage.getItem("userRole"));
    this.DealerReg = (localStorage.getItem("DealerReg") == 'true' && this.userRole == 'Dealer');
  }

  ngOnInit(): void {
    this.notifService.startPolling();
    this.notifSub.add(
      this.notifService.notifications$.subscribe(n => this.notifications = n)
    );
    this.notifSub.add(
      this.notifService.unreadCount$.subscribe(c => this.unreadCount = c)
    );
    this.notifSub.add(
      this.notifService.newNotifications$.subscribe(items => this._showToast(items))
    );
  }

  toggleNotifPanel(): void {
    this.notifPanelOpen = !this.notifPanelOpen;
  }

  markRead(id: number): void {
    this.notifService.markRead(id);
  }

  markAllRead(): void {
    this.notifService.markAllRead();
  }

  dismissToast(id: number): void {
    this.toastQueue = this.toastQueue.filter(t => t.id !== id);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.notif-wrapper')) {
      this.notifPanelOpen = false;
    }
  }

  public logOutUser() {
    this.notifService.stopPolling();
    this.authService.Logout(localStorage.getItem("IDENTIFIER"));
    this.authService.resetcredentials();
    this.router.navigate([""]);
  }

  ngOnDestroy(): void {
    this.notifSub.unsubscribe();
    this.toastTimers.forEach(t => clearTimeout(t));
  }

  private _showToast(items: AppNotification[]): void {
    if (items.length === 1) {
      const n = items[0];
      const id = ++this.toastCounter;
      this.toastQueue.push({ message: n.notificationSubject, id, severityClass: this._severityClass(n.severity) });
      const t = setTimeout(() => this.dismissToast(id), 6000);
      this.toastTimers.push(t);
    } else {
      const id = ++this.toastCounter;
      this.toastQueue.push({ message: `You have ${items.length} new Admin status updates`, id, severityClass: 'notif-toast--info' });
      const t = setTimeout(() => this.dismissToast(id), 6000);
      this.toastTimers.push(t);
    }
  }

  private _severityClass(severity: number): string {
    switch (severity) {
      case NotificationSeverity.Success: return 'notif-toast--success';
      case NotificationSeverity.Error:   return 'notif-toast--error';
      case NotificationSeverity.Warning: return 'notif-toast--warning';
      default:                           return 'notif-toast--info';
    }
  }
}
